import { Directive, ElementRef, Input, inject } from '@angular/core';
import { Select } from '@ngxs/store';
import { BaseColumn } from '@shared/classes/base-column';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CommonDataState } from '@shared/stores/common-data.state';
import { UserProfile } from '@shared/classes/user-profile';
import { PermissionService } from '@shared/services/permission-service';
import { DrivingBehavior } from '../classes/driving-behavior';

@Directive({
  selector: '[disableEditButton]',
  standalone: true,
})
export class DisableEditButtonDirective {
  permissionService = inject(PermissionService);

  destroy$ = new Subject();

  @Select(CommonDataState.profileMe) profileMe$: Observable<UserProfile>;

  constructor(private elementRef: ElementRef) {
  }

  @Input() set disableEditButton(selectedItems: BaseColumn[]) {
    var disabled = !selectedItems || selectedItems.length !== 1;

    this.profileMe$.pipe(takeUntil(this.destroy$)).subscribe(profileMe => {
      disabled = this.permissionService.checkDriverAdminContainsOtherUsersData(profileMe, selectedItems) || disabled;
      if (this.permissionService.checkIsDrivingBehavior(selectedItems[0] as DrivingBehavior)) {
        disabled = disabled || !this.permissionService.checkDriverBehaviorIsDriverObservationKpi(selectedItems[0] as DrivingBehavior);
      }

      if (this.elementRef && this.elementRef.nativeElement) {
        this.elementRef.nativeElement.disabled = disabled;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
